(function () {
  function initLookHomeCarousel(carousel) {
    var track = carousel.querySelector('[data-lkh-track]');
    var prevBtn = carousel.querySelector('[data-lkh-prev]');
    var nextBtn = carousel.querySelector('[data-lkh-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollStep() {
      var card = track.querySelector('.lk-home__card');
      if (!card) return track.offsetWidth;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.offsetWidth;
      prevBtn.classList.toggle('lk-home__arrow--hidden', track.scrollLeft < 2);
      nextBtn.classList.toggle('lk-home__arrow--hidden', track.scrollLeft >= maxScroll - 2);
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    updateArrows();
  }

  document.querySelectorAll('[data-lkh-carousel]').forEach(initLookHomeCarousel);
})();
